"use strict";
const angular = require("angular");

export class ShareComponent {
  /*@ngInject*/
  constructor() {
    var that = this;
    this.$onInit = function () {
      that.users = that.resolve.users;
      that.createdBy = that.resolve.createdBy;
    };

    this.cancel = function () {
      this.dismiss();
    };
  }

  save(form) {
    let that = this;
    this.submitted = true;
    if (form.$valid) {
      that.close({ $value: { email: that.email, op: "add" } });
    }
  }

  delete(emailSelected) {
    this.close({ $value: { email: emailSelected, op: "remove" } });
  }
}

export default angular
  .module("dalApp.permission.share", [])
  .component("share", {
    template: require("./share.html"),
    controller: ShareComponent,
    bindings: {
      resolve: "<",
      close: "&",
      dismiss: "&",
    },
  }).name;



// WEBPACK FOOTER //
// ./client/app/permission/share/share.component.js